import React, { useRef } from 'react'
import './footer.css'
import emailjs from 'emailjs-com';
import github from './icons/github.svg'
import linkedin from './icons/linkedin.svg'

const Footer = () => {

  const form = useRef();


  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_uxwk4he', 'template_ithn1un', form.current, 'EjsAOrqWH7Zp0HCRf')
      
  };
  
  return (
    <section className='footer '>
      <div className="footer-header">
        Enough Talking about me! Let's talk about you.
      </div>
      <div className="form">
        <form className='contact' ref={form} onSubmit={sendEmail}>

        <div className="form-group">
          
        <div className="form-element">
        <label>Name</label>
        <input type="text" name="name" id='name' required/>
        </div>

        <div className="form-element">
        <label>Email</label>
        <input type="email" name="email" id='email' required/>
        </div>

        </div>

        <div className="form-element">
        <label>Tell me about your project</label>
        <textarea name="message" id='message' required/>
        </div>  
        
        
        
        <input type="submit" value="Send" className='button input-button'/>
        
    </form>
      </div>

      <div className="footer-bottom">
        <div className="footer-left">
          NEGGAZHICHEM@GMAIL.COM
        </div>

        <div className="footer-right">

          <a href="https://github.com/HichemNgz/" target="_blank" rel="noopener noreferrer">
            <img src={github} alt="" className='work-icon'/>
          </a>

          <a href="https://www.linkedin.com/in/hichem-neggaz-15a742238/" target="_blank" rel="noopener noreferrer">
            <img src={linkedin} alt="" className='work-icon'/>
          </a>
        </div>
      </div>
    </section>
  )
}

export default Footer
